export interface JobStatusResponse {
  status: "queued" | "running" | "completed" | "failed";
  animation_id?: string;
  version_id?: string;
  error?: string;
}

export async function waitForJob(jobId: string, opts?: { intervalMs?: number; timeoutMs?: number }): Promise<JobStatusResponse> {
  const intervalMs = opts?.intervalMs ?? 1500;
  const timeoutMs = opts?.timeoutMs ?? 12000000;
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    const res = await fetch(`/api/jobs/${jobId}`);
    if (!res.ok) {
      throw new Error("Failed to check job status");
    }
    const data = (await res.json()) as JobStatusResponse;
    if (data.status === "completed" || data.status === "failed") {
      return data;
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  throw new Error("Generation timed out. Please try again.");
}
